
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import CurrentMonthCustomer from "../components/currentMonthGetInfo";
import Footer from "../components/footer";

function CurrentMonthPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      <CurrentMonthCustomer /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default CurrentMonthPage;
